export default __webpack_public_path__ + "static/media/All.86bb747b.png";